// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Autocomplete,
  Box,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  createFilterOptions,
  Fade,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";

import { gql, useMutation, useQuery, useLazyQuery } from "@apollo/client";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
// import { ConfirmarContext } from "context/ConfirmarContext";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import {
  parseSeccionesComanda,
  serializeSeccionesComanda,
  SECCIONES_COMANDA,
} from "utils/seccionesComanda";

const filter = createFilterOptions();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "90%", sm: "60%", xxl: "50%" },
  overflowY: "auto",
  p: 3,
};

const productoInicial = {
  nombre: "",
  idCategoria: "",
  idTipo: "",
  precioCarta: "",
  precioOnline: "",
  descripcion: "",
  productos: [],
  idsCombo: [],
  seccion: ["Cocina"],
};
export default function ModalCombo({
  open,
  handleClose,
  refetch,
  selectedProducto,
  categorias,
  // tiposProducto,
}) {
  const [producto, setProducto] = useState(productoInicial);
  // const [file, setFile] = useState(null);

  const handleChangeProducto = (e) => {
    const { name, value } = e.target;
    setProducto({
      ...producto,
      [name]:
        name === "seccion"
          ? parseSeccionesComanda(typeof value === "string" ? value.split(",") : value)
          : value,
    });
  };
  const { handleSnackbar } = useContext(MessageManager);
  // const { confirmar } = useContext(ConfirmarContext);

  const [saveProducto, { loading: loadingSave }] = useMutation(
    gql`
      mutation saveProducto($input: ProductoInput!) {
        saveProducto(input: $input) {
          id
        }
      }
    `
  );

  const PRODUCTOS_QUERY = gql`
    query productos {
      productos {
        id
        nombre
      }
    }
  `;

  const [getProductos, { data: productos }] = useLazyQuery(PRODUCTOS_QUERY, {
    fetchPolicy: "no-cache",
  });

  const [getAreas, { data: areas }] = useLazyQuery(
    gql`
      query areas {
        areaProductos {
          id
          nombre
        }
      }
    `,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    if (open) {
      getProductos();
      getAreas();
    }
  }, [open]);
  const handleSave = () => {
    let idsCombo = producto.productos?.map((producto) => producto.id);
    saveProducto({
      variables: {
        input: {
          id: selectedProducto ? selectedProducto.id : null,
          idTipo: producto.idTipo || null,
          idCategoria: producto.idCategoria,
          idArea: producto.idArea,
          nombre: producto.nombre,
          descripcion: producto.descripcion,
          precioCarta: producto.precioCarta || null,
          precioOnline: producto.precioOnline || null,
          combo: true,
          idsCombo: idsCombo,
          seccion: serializeSeccionesComanda(producto.seccion),
        },
      },
    })
      .then(() => {
        handleSnackbar("Producto guardado correctamente", "success");
        refetch();
        handleClose();
      })
      .catch((error) => {
        const errorMessage = error?.graphQLErrors?.[0]?.message || "Error al guardar";
        handleSnackbar(errorMessage, "error");
      });
  };

  useEffect(() => {
    if (selectedProducto) {
      setProducto({
        ...selectedProducto,
        productos: selectedProducto.productosCombo,
        idCategoria: selectedProducto?.categoriaProducto?.id || null,
        idTipo: selectedProducto.tipoProducto?.id,
        idArea: selectedProducto?.area?.id || "",
        seccion: parseSeccionesComanda(selectedProducto?.seccion),
      });
    } else {
      setProducto(productoInicial);
    }
  }, [selectedProducto, open]);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Combo</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox py={2}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={8}>
                  <InputLabel htmlFor="nombre">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Nombre
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    placeholder="Ingrese el nombre"
                    type="text"
                    name="nombre"
                    value={producto.nombre}
                    onChange={handleChangeProducto}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputLabel htmlFor="nombre">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Sección comandera
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <Select
                    placeholder="Seleccione sección comandera"
                    multiple
                    value={producto.seccion || []}
                    onChange={handleChangeProducto}
                    name="seccion"
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((seccion, index) => (
                          <Chip key={seccion + index} label={seccion} />
                        ))}
                      </Box>
                    )}
                  >
                    {SECCIONES_COMANDA.map((seccion) => (
                      <MenuItem key={seccion} value={seccion}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Checkbox
                            checked={(producto.seccion || []).indexOf(seccion) > -1}
                            sx={{ mr: 1, p: 0 }}
                          />
                          {seccion}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <InputLabel htmlFor="Producost">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Comidas/Bebidas incluidas
                    </SoftTypography>
                  </InputLabel>
                  <Autocomplete
                    multiple
                    id="tags-filled"
                    freeSolo
                    options={productos?.productos.map((option) => option) || []}
                    getOptionLabel={(option) => {
                      return option.nombre;
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      return filtered;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                    name="productos"
                    value={producto.productos || []}
                    onChange={(e, newValue) => {
                      setProducto({ ...producto, productos: newValue });
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <InputLabel htmlFor="categoria">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Categoría
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <Select
                    placeholder="Seleccione una categoría"
                    value={producto.idCategoria}
                    onChange={handleChangeProducto}
                    name="idCategoria"
                  >
                    {categorias.map((categoria) => (
                      <MenuItem key={categoria.id} value={categoria.id}>
                        {categoria.categoria}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {/* <Grid
                  item
                  xs={6}
                  sm={6}
                  display="flex"
                  flexDirection="column"
                  justifyContent="flex-end"
                >
                  <SoftBox display="flex" justifyContent="space-between" pb={0.3}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Tipo &nbsp;
                    </SoftTypography>
                  </SoftBox>
                  <Select
                    placeholder="Seleccione un tipo"
                    value={producto.idTipo}
                    onChange={handleChangeProducto}
                    name="idTipo"
                  >
                    {tiposProducto.map((tipo) => (
                      <MenuItem key={tipo.id} value={tipo.id}>
                        {tipo.tipo}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid> */}
                <Grid item xs={6} sm={6}>
                  <InputLabel htmlFor="precioCarta">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Precio Carta
                    </SoftTypography>
                  </InputLabel>
                  <SoftInputNumber
                    label="precioCarta"
                    placeholder="Ingrese el precio"
                    icon={{
                      component: <Icon color="primary">attach_money</Icon>,
                      direction: "left",
                    }}
                    name="precioCarta"
                    value={producto.precioCarta}
                    onChange={handleChangeProducto}
                  />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <InputLabel htmlFor="precioOnline">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Precio Online
                    </SoftTypography>
                  </InputLabel>
                  <SoftInputNumber
                    label="precioOnline"
                    placeholder="Ingrese el precio"
                    icon={{
                      component: <Icon color="primary">attach_money</Icon>,
                      direction: "left",
                    }}
                    name="precioOnline"
                    value={producto.precioOnline}
                    onChange={handleChangeProducto}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputLabel htmlFor="area">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Área
                      <SoftTypography variant="caption" fontWeight="bold" color="primary">
                        &nbsp;*
                      </SoftTypography>
                    </SoftTypography>
                  </InputLabel>
                  <Select
                    name="idArea"
                    value={producto.idArea || ""}
                    onChange={(e) => {
                      setProducto({
                        ...producto,
                        idArea: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value="" disabled>
                      Seleccione un área
                    </MenuItem>
                    {areas?.areaProductos?.map((area) => (
                      <MenuItem key={area.id} value={area.id}>
                        {area.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <InputLabel htmlFor="descripcion">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Descripción
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    label="descripcion"
                    placeholder="Descripción del producto"
                    type="text"
                    name="descripcion"
                    multiline
                    rows={2}
                    value={producto.descripcion}
                    onChange={handleChangeProducto}
                  />
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="flex-end"
              alignItems="center"
            >
              <SoftBox
                display={{
                  xs: "flex-row",
                  sm: "flex",
                }}
                justifyContent="end"
                alignItems="center"
              >
                <SoftBox
                  mr={{
                    xs: 0,
                    sm: 2,
                  }}
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="primary"
                    circular
                    onClick={handleClose}
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    disabled={loadingSave}
                  >
                    <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                    &nbsp;Cancelar
                  </SoftButton>
                </SoftBox>
                <SoftBox
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="uproGreen"
                    circular
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    onClick={handleSave}
                    disabled={loadingSave || !producto.nombre || !producto.idCategoria}
                  >
                    {false ? (
                      <CircularProgress size={15} color="inherit" />
                    ) : (
                      <Icon sx={{ fontWeight: "light" }}>save</Icon>
                    )}
                    &nbsp;Guardar
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalCombo.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  selectedProducto: PropTypes.object,
  categorias: PropTypes.array,
  tiposProducto: PropTypes.array,
};
